import {
  CheckCircle as CheckCircleIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const GreetingModal = ({ open, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 1,
        },
      }}
    >
      <DialogTitle sx={{ textAlign: "center", position: "relative", pb: 1 }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", px: 3, py: 2 }}>
        <Box sx={{ mb: 3 }}>
          <CheckCircleIcon
            sx={{
              fontSize: 60,
              color: "success.main",
              mb: 2,
            }}
          />
        </Box>

        <Typography
          variant="h6"
          component="h2"
          sx={{
            fontWeight: 600,
            mb: 2,
            color: "text.primary",
          }}
        >
          Şirketimize göstermiş olduğunuz ilgi için teşekkür ederiz.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mb: 2,
            color: "success.main",
            fontWeight: 500,
          }}
        >
          Başvurunuz aday sistemimize başarıyla kayıt edilmiştir.
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            lineHeight: 1.6,
          }}
        >
          Başvurmuş olduğunuz bölüm ya da pozisyonda ihtiyaç oluşması halinde
          tarafınızla bağlantıya geçiyor olacağız.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3, px: 3 }}>
        <Button
          onClick={onClose}
          variant="contained"
          size="large"
          sx={{
            minWidth: 120,
            borderRadius: 2,
            textTransform: "none",
          }}
        >
          Tamam
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GreetingModal;
